import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44ed27e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-new-business-title-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "main-title-box" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "main-title-left-box" }, "店铺情况")
  ])
], -1))
const _hoisted_2 = {
  key: 0,
  class: "main-new-business-content-box"
}
const _hoisted_3 = { class: "main-new-business-static-item-box" }
const _hoisted_4 = { class: "main-new-business-static-inner-box" }
const _hoisted_5 = { class: "static-child-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "有效期", -1))
const _hoisted_7 = { style: {"font-size":"18px","margin":"4px 0"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-new-business-title-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "main-title-box" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "main-title-left-box" }, "实时概况")
  ])
], -1))
const _hoisted_9 = {
  key: 0,
  class: "main-new-business-content-box"
}
const _hoisted_10 = { class: "main-new-business-static-item-box" }
const _hoisted_11 = { class: "main-new-business-static-inner-box" }
const _hoisted_12 = { class: "static-child-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "今日支付订单数", -1))
const _hoisted_14 = { class: "static-child-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "今日支付金额(元)", -1))
const _hoisted_16 = {
  key: 0,
  class: "static-child-item"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "浏览量", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "-", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "昨日 -", -1))
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "static-child-item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "累积客户数", -1))
const _hoisted_23 = { class: "main-new-business-static-item-box" }
const _hoisted_24 = { class: "main-new-business-static-inner-box" }
const _hoisted_25 = { class: "static-child-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "等待付款", -1))
const _hoisted_27 = { class: "static-child-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "完成订单", -1))
const _hoisted_29 = { class: "static-child-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "等待发货", -1))
const _hoisted_31 = { class: "static-child-item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "售后处理", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, {
    title: _ctx.store.name
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_ui_card, { class: "main-new-business-box" }, {
        title: _withCtx(() => [
          _createVNode(_component_ui_title, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$format(_ctx.store.endTime, 'YYYY-MM-DD')), 1),
                      _createElementVNode("div", {
                        style: {"cursor":"pointer"},
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.renewal && _ctx.renewal(...args)))
                      }, "续费")
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_ui_card, { class: "main-new-business-box" }, {
        title: _withCtx(() => [
          _createVNode(_component_ui_title, null, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", null, _toDisplayString(_ctx.data.order.todayPayCount), 1),
                      _createElementVNode("div", null, "昨日 " + _toDisplayString(_ctx.data.order.yesterdayPayCount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", null, _toDisplayString(_ctx.data.order.todayPayAmount), 1),
                      _createElementVNode("div", null, "昨日 " + _toDisplayString(_ctx.data.order.yesterdayPayAmount), 1)
                    ]),
                    false
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_20))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("div", null, _toDisplayString(_ctx.data.userCount), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", null, _toDisplayString(_ctx.data.order.waitPay), 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", null, _toDisplayString(_ctx.data.order.success), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("div", null, _toDisplayString(_ctx.data.order.waitSend), 1)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", null, _toDisplayString(_ctx.data.order.sellAfter), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}